import React from "react";
import { Route, Routes } from "react-router-dom";
import MasterParts from "./masterParts/MasterParts";
import MasterInventory from "./masterInventory/MasterInventory";
import MasterLabor from "./masterLabor/MasterLabor";
import InventoryList from "./inventoryList/InventoryList";
import InventoryAdjustment from "./InventoryAdjustment.tsx/InventoryAdjustment";
import RepairOrderManagement from "./repair/RepairOrderManagement";
import ServiceMaster from "./serviceMaster/ServiceMaster";
import ServiceRequest from "./serviceRequest/ServiceRequest";
import Appointment from "./Appointment/Appointment";
import GetServiceDetails from "./serviceRequest/GetServiceDetails";
import GetAppintmentDetails from "./Appointment/GetAppintmentDetails";
import Feedback from "./feedback/Feedback";
import ERCSConfiguration from "./configuration/ERCSConfiguration";
import Policy from "./policy/Policy";
import Leads from "./Leads/Leads";

const Index = () => {
  return (
    <Routes>
      <Route
        path="/master-parts"
        element={
          <>
            <MasterParts />
          </>
        }
      />
      <Route
        path="/master-inventory"
        element={
          <>
            <MasterInventory />
          </>
        }
      />

      <Route
        path="/master-labor"
        element={
          <>
            <MasterLabor />
          </>
        }
      />
      <Route
        path="/list"
        element={
          <>
            <InventoryList />
          </>
        }
      />
      <Route
        path="/adjustment"
        element={
          <>
            <InventoryAdjustment />
          </>
        }
      />

      <Route
        path="/repair-order"
        element={
          <>
            <RepairOrderManagement />
          </>
        }
      />

      <Route
        path="/service-master"
        element={
          <>
            <ServiceMaster />
          </>
        }
      />

      <Route
        path="/service-request"
        element={
          <>
            <ServiceRequest />
          </>
        }
      />

      <Route
        path="/service-request/*"
        element={
          <>
            <GetServiceDetails />
          </>
        }
      />

      <Route
        path="/Appointment"
        element={
          <>
            <Appointment />
          </>
        }
      />

      <Route
        path="/Appointment/*"
        element={
          <>
            <GetAppintmentDetails />
          </>
        }
      />

      <Route
        path="/feedback"
        element={
          <>
            <Feedback />
          </>
        }
      />

      <Route
        path="/configuration"
        element={
          <>
            <ERCSConfiguration />
          </>
        }
      />

      <Route
        path="/policy"
        element={
          <>
            <Policy />
          </>
        }
      />

      <Route
        path="/leads"
        element={
          <>
            <Leads />
          </>
        }
      />
    </Routes>
  );
};

export default Index;
